import { BoxIcon } from '#atoms';
import { useFormContext } from 'react-hook-form';

const Checkbox = ({
  registerName,
  labelTitle,
  onCustomChange,
  wrapperClassName,
  checked
}: {
  registerName: string;
  labelTitle: string;
  onCustomChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  wrapperClassName?: string;
  checked?: boolean;
}) => {
  const { register } = useFormContext();

  return (
    <div
      className={`flex justify-center items-center gap-5 ${wrapperClassName}`}
    >
      <div className="flex items-center relative">
        <div className="flex items-center relative">
          <input
            {...register(registerName, {
              onChange: onCustomChange
            })}
            id={`checked-${registerName}`}
            type="checkbox"
            className="appearance-none w-18 h-18 peer bg-transparent z-1"
            checked={checked}
          />
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-18 h-18 bg-[#2E2B36] peer-checked:bg-[#7750E9] rounded-5 flex justify-center items-center">
            <BoxIcon type="check-white" size={10} boxColor="transparent" />
          </div>
        </div>
      </div>
      {labelTitle ? (
        <label htmlFor={`checked-${registerName}`} className="text-[#C9C7D1]">
          {labelTitle}
        </label>
      ) : null}
    </div>
  );
};

export default Checkbox;
